import router from '@/router';
import { $post, $api } from '@/service/request';

const mockdata = {
	task_id: 0,
	status: 1,
	commodity_info: {
		commodity_name: '车载u盘',
		commodity_price: 88,
		commodity_picture: 'http://static1.kaixinyf.cn/img/lza60ac75318cfa0830789893.png',
		commodity_style_name: '升级版粉色',
		countdown: 1000,
		commodity_style_list: [
			{
				style_id: 1,
				style_name: '升级版粉色',
				style_picture: 'http://static1.kaixinyf.cn/img/lza60ac75318cfa0830789893.png',
			},
			{
				style_id: 2,
				style_name: '升级版蓝色',
				style_picture: 'http://static1.kaixinyf.cn/img/lza60ac75318cfa0830789893.png',
			},
			{
				style_id: 3,
				style_name: '普通版银色',
				style_picture: 'http://static1.kaixinyf.cn/img/lza60ac75318cfa0830789893.png',
			},
			{
				style_id: 4,
				style_name: '普通版黑色',
				style_picture: 'http://static1.kaixinyf.cn/img/lza60ac75318cfa0830789893.png',
			},
		],
		select_commodity_style: {
			style_id: 2,
			style_name: '升级版蓝色',
			style_picture: 'http://static1.kaixinyf.cn/img/lza60ac75318cfa0830789893.png',
		},
	},
	win_info: [
		{
			id: 1,
			avatar: 'http://static1.kaixinyf.cn/img/a7057af4e02d12b0dc340b5f56dfcfd3.png?x-oss-process=image/resize,m_fixed,h_128,w_128',
			nickname: '用户昵称展示',
			message: '车载U盘×1',
		},
		{
			id: 2,
			avatar: 'http://static1.kaixinyf.cn/img/7603ea6da193d8c775051e86d6b152d4.png?x-oss-process=image/resize,m_fixed,h_128,w_128',
			nickname: 'ky_5092004',
			message: '车载U盘×1',
		},
		{
			id: 2,
			avatar: 'http://static1.kaixinyf.cn//img/d4fc19c2491806fc9e1b50084108840b.png?x-oss-process=image/resize,m_fixed,h_128,w_128',
			nickname: '用快音听歌真棒',
			message: '车载U盘×1',
		},
	],
	win_num: 2345,
	user_address: {
		uid: '5092004',
		customer_name: 'yuan',
		customer_phone: '18883335562',
		customer_address: '四川省成都市高新区太平洋保险大厦16楼',
	},
	user_info: {
		nickname: 'ky_5092004',
		avatar_small: 'http://static3.kuaiyin123.cn/img/lza5e8ed0642c09c784159427.png',
	},
	order_create_time: '2021年6月1日',
};

export default {
	namespaced: true,
	state: () => ({
		currentStep: 0,

		// 选中的商品类型
		goodsType: {
			style_id: '',
			style_name: '',
			style_picture: '',
		},

		// 商品信息
		commodityInfo: {
			commodity_name: '',
			commodity_price: 0,
			commodity_picture: '',
			commodity_style_name: '',

			commodity_style: [],
		},

		// 用户地址信息
		addressInfo: {
			user_name: '-',
			mobile: '-',
			address: '-',
		},

		// 用户账号信息
		userInfo: {
			nickname: '',
			avatar_small: '',
		},

		// 获奖信息
		invitInfo: {
			need_invite_num: 2,
			current_invited_num: 2,
			invitedUserInfo: [],
		},

		// 获得奖励的总人数
		winNum: 0,

		// fake获奖信息
		fakeWinInfo: [],

		// 1-未开始 2-进行中 3-活动成功 4-失败
		status: 1,

		taskId: 0,

		// 任务倒计时
		countdown: 3600 * 3,

		// 订单开始时间
		orderCreateTime: '',
		//  邀请按钮文案
		inviteTxt: '',
	}),
	mutations: {
		setCurrentStep(state, count) {
			state.currentStep = count;
		},

		setGoodsType(state, type) {
			state.goodsType = type;
		},

		setAddressInfo(state, data) {
			state.addressInfo = { ...data };
		},

		setStatus(state, status) {
			state.status = status;
		},

		setCountdown(state, count) {
			state.countdown = count;
		},
		reduceCountdown(state) {
			state.countdown = state.countdown - 1;
		},

		setCommodityInfo(state, data) {
			state.commodityInfo = { ...data };
		},

		setFakeWinInfo(state, list) {
			state.fakeWinInfo = [...list];
		},

		setUserInfo(state, data) {
			state.userInfo = { ...data };
		},

		setWinNum(state, payload) {
			state.winNum = payload;
		},

		setOrderCreateTime(state, time) {
			state.orderCreateTime = time;
		},

		setTaskId(state, id) {
			state.taskId = id;
		},

		setInvitInfo(state, data) {
			state.invitInfo = { ...data };
		},
		setInviteTxt(state, data) {
			state.inviteTxt = data;
		},
	},
	actions: {
		async getMaterialRewardPageInfo({ commit }) {
			const res = await $post($api.GET_COMMODITY_PAGE_INFO);
			if (+res.code === 0) {
				let {
					status,
					commodity_info,
					user_address,
					user_info,
					win_info,
					win_num,
					order_create_time,
					task_id,
					countdown,
					pop_countdown,
					need_invite_num,
					current_invited_num,
					invitedUserInfo,
					invite_txt,
				} = res.data;
				commit('setInviteTxt', invite_txt);
				commit('setTaskId', task_id);
				commit('setCommodityInfo', commodity_info);
				const { customer_name, customer_phone, customer_address } = user_address;
				commit('setAddressInfo', {
					user_name: customer_name,
					mobile: customer_phone,
					address: customer_address,
				});
				commit('setWinNum', win_num);
				commit('setUserInfo', user_info);
				commit('setFakeWinInfo', win_info);
				commit('setOrderCreateTime', order_create_time);

				if (status == 1) {
					commit('setCountdown', pop_countdown);
				} else {
					commit('setCountdown', countdown);
				}

				commodity_info.select_commodity_style && commit('setGoodsType', commodity_info.select_commodity_style);

				// status = 1
				commit('setStatus', status);

				// TODO mock
				// invitedUserInfo = [
				// 	{
				// 		nickname: 'ky_5092005',
				// 		avatar_small: 'http://static1.kaixinyf.cn/img/lza5e8ed0642c09c784159427.png',
				// 	},
				// 	{
				// 		nickname: '习去你那看看a',
				// 		avatar_small:
				// 			'http://static1.kaixinyf.cn/cover/dacd81b4e50c4f63999f11ef197701d7.png?x-oss-process=image/resize,m_fixed,h_128,w_128',
				// 	},
				// 	{
				// 		nickname: '习去你那看看a',
				// 		avatar_small:
				// 			'http://static1.kaixinyf.cn/cover/dacd81b4e50c4f63999f11ef197701d7.png?x-oss-process=image/resize,m_fixed,h_128,w_128',
				// 	},
				// ];
				// need_invite_num = 2;
				// current_invited_num = 1;

				const delta = need_invite_num - current_invited_num;
				let formatInviteInfo = [...invitedUserInfo];
				for (let i = 0; i < delta; i++) {
					formatInviteInfo.push({
						nickname: '',
						avatar_small: '',
					});
				}
				commit('setInvitInfo', {
					need_invite_num,
					current_invited_num,
					invitedUserInfo: formatInviteInfo,
				});
			}
		},
	},
	getters: {
		step(state) {
			const { goodsType, addressInfo, status } = state;
			if (status != 1) {
				return 2;
			}
			if (goodsType.style_id) {
				if (addressInfo.user_name && addressInfo.mobile && addressInfo.address) {
					return 2;
				}
				return 1;
			} else {
				return 0;
			}
		},

		isComplate(state) {
			const { invitInfo } = state;
			return +invitInfo.need_invite_num !== 0 && +invitInfo.need_invite_num === +invitInfo.current_invited_num;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/ActivityPage/modules/material_reward.js